import React, { Component } from 'react';
import './App.css';
import 'antd/dist/antd.css';

import { Route, Switch } from 'react-router-dom'
import { Redirect } from 'react-router'

import DemoList from './models/list/'
import DiabetesForm from './models/diabetes/predict/'

class App extends Component {
  componentDidMount() {
    document.title = "Pluto7 - ML Demo"
  }

  render() {

    return (
      <Switch>
        <Route exact path='/' render={() => (
          <Redirect to="/models/list"/>
        )}/>
        <Route path='/models/list' component={DemoList}/>
        <Route path='/models/diabetes/predict' component={DiabetesForm}/>
      </Switch>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js